import { useFiltersApi } from '@/hooks'
import { ActiveManagementFiltersValues } from '@/utils/constants'
import { useMemo } from 'react'
import { useActiveManagementFiltersGetParams } from './useActiveManagementFiltersGetParams'

type Props = {
    activeFilters: ActiveManagementFiltersValues
}

export const useActiveManagementSubmetersQuery = ({ activeFilters }: Props) => {
    const { useSubmetersQuery } = useFiltersApi()
    const params = useActiveManagementFiltersGetParams(activeFilters)

    const submetersQueryParams = useMemo(
        () => ({
            'nodeIds[]': params['nodeIds[]'],
            'tagIds[]': params['tagIds[]'],
            'facilityIds[]': params['facilityIds[]'],
            'usnAccountIds[]': params['usnAccountIds[]'],
        }),
        [params]
    )

    return useSubmetersQuery(submetersQueryParams)
}
